// // RegistrationForm.js
// import React, { Component } from 'react';
// import { Card, Form, Button, Row, Col } from 'react-bootstrap';

// export class RegistrationForm extends Component {
//   render() {
//     const { title, subtitle, onSubmit } = this.props;
//     return (
//       <Card bg="light" className="p-4 border-0">
//         <Card.Body>
//           <Card.Title className="text-dark">{title}</Card.Title>
//           <Card.Text className="text-muted">{subtitle}</Card.Text>

//           <Form onSubmit={onSubmit}>
//             <Form.Group controlId="email" className="mt-3">
//               <Form.Control type="email" placeholder="Email Address" />
//             </Form.Group>
//             <Button
//               variant="primary"
//               type="submit"
//               className="w-100 mt-3"
//             >
//               Submit
//             </Button>
//           </Form>
//         </Card.Body>
//       </Card>
//     );
//   }
// }


// RegistrationForm.js
import React, { Component } from 'react';
import { Card, Form, Button } from 'react-bootstrap';

export class RegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = { email: '' };
    this.handleChange  = this.handleChange.bind(this);
    this.handleSubmit  = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ email: e.target.value });
  }

  async handleSubmit(e) {
    e.preventDefault();
    const { email } = this.state;
    try {
      // 1️⃣ Call your backend to subscribe to Brevo
      const res = await fetch('https://justingirard.com/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      // 2️⃣ If you had any parent handler, call it
      if (this.props.onSubmit) {
        this.props.onSubmit(email);
      }
      // 3️⃣ (Optional) give user feedback
      alert('Thanks for subscribing!');
      this.setState({ email: '' });
    } catch (err) {
      console.error(err);
      alert('Subscription failed. Please try again.');
    }
  }

  render() {
    const { title, subtitle } = this.props;
    const { email } = this.state;

    return (
      <Card bg="light" className="p-4 border-0">
        <Card.Body>
          <Card.Title className="text-dark">{title}</Card.Title>
          <Card.Text className="text-muted">{subtitle}</Card.Text>

          <Form onSubmit={this.handleSubmit}>
            <Form.Group controlId="email" className="mt-3">
              <Form.Control
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={this.handleChange}
                required
              />
            </Form.Group>
            <Button
              variant="primary"
              type="submit"
              className="w-100 mt-3"
              disabled={!email}
            >
              Submit
            </Button>
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
